import React from 'react';
import {
  ResourcesMegaMenuLinksContainerProps,
  ResourcesMegaMenuLink,
  ResourcesMegaMenuLinksContainer,
  ResourcesMegaMenuLinksContent,
  ResourcesMegaMenuLinksSection,
} from './ResourcesMegaMenuLinks.styles';
import ResourcesMegaMenuLinksData from './ResourcesMegaMenuLinksData';
import Paragraph from 'src/elements/typography/paragraph';
import { palette } from 'src/styles/colors';

const ResourcesMegaMenuLinks = ({ isFullWidth = false }: ResourcesMegaMenuLinksContainerProps): JSX.Element => (
  <ResourcesMegaMenuLinksContainer isFullWidth={isFullWidth}>
    <ResourcesMegaMenuLinksContent>
      {ResourcesMegaMenuLinksData.map((section) => (
        <ResourcesMegaMenuLinksSection key={section.title}>
          <Paragraph
            standardSize='0.75'
            letterSpacing={1.5}
            text={section.title}
            align='left'
            weight={600}
            className='feature-links-section-title'
            color={palette.darkSilver}
          />
          {section.links
            .filter((link) => !link.hidden)
            .map((link, index) => (
              <ResourcesMegaMenuLink
                key={index}
                to={link.href}
                target={link.href.startsWith('http') ? '_blank' : undefined}
              >
                <Paragraph
                  standardSize='1'
                  weight={700}
                  text={link.text}
                  className='link-title'
                />
              </ResourcesMegaMenuLink>
            ))}
        </ResourcesMegaMenuLinksSection>
      ))}
    </ResourcesMegaMenuLinksContent>
  </ResourcesMegaMenuLinksContainer>
);

export default ResourcesMegaMenuLinks;
